import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { Node } from '@alfresco/js-api';
import { ContentNodeSelectorComponentData } from '@alfresco/adf-content-services';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'wk-content-node-selector',
  templateUrl: './wk-content-node-selector.component.html',
  styleUrls: ['./wk-content-node-selector.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class WkContentNodeSelectorComponent {
  buttonActionName: string;
  chosenNode: Node[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ContentNodeSelectorComponentData,
    private readonly containingDialog?: MatDialogRef<WkContentNodeSelectorComponent>
  ) {
    this.buttonActionName = data.actionName
      ? `NODE_SELECTOR.${data.actionName.toUpperCase()}`
      : 'NODE_SELECTOR.CHOOSE';
  }

  close() {
    this.data.select.complete();
  }

  onSelect(nodeList: Node[]) {
    this.chosenNode = nodeList;
  }

  onClick(): void {
    this.data.select.next(this.chosenNode);
    this.containingDialog?.close();
  }
}
